import {UntypedFormGroup, ValidationErrors, AbstractControl, ValidatorFn} from '@angular/forms';
import { getRoleFromName } from '../shared';

export class AccessSectionValidator {
  public static validate(form: UntypedFormGroup): ValidationErrors | any {
    if (!form)
      return null;

    // Get control references
    const userTypeCtrl = form.get('userType');
    const corporationNameCtrl = form.get('corporationName');
    //const careSettingNameCtrl = form.get('careSettingName');
    const roleCtrl = form.get('role');
    if (((userTypeCtrl.value === undefined) || (userTypeCtrl.value === null) || (userTypeCtrl.value.trim() === '')) &&
      ((corporationNameCtrl.value === undefined) ||
        (corporationNameCtrl.value === null) ||
        (corporationNameCtrl.value.trim() === '')) &&
      ((roleCtrl.value === undefined) || (roleCtrl.value === null) || (roleCtrl.value.trim() === ''))) {

      userTypeCtrl.setErrors(null);
      corporationNameCtrl.setErrors(null);
      roleCtrl.setErrors(null);

      return null;
    } else {
      if ((userTypeCtrl.value !== '') &&
        (corporationNameCtrl.value !== '') &&
          ((roleCtrl.value !== undefined) && (roleCtrl.value !== null) && (roleCtrl.value.trim() !== ''))) {

        userTypeCtrl.setErrors(null);
        corporationNameCtrl.setErrors(null);
        roleCtrl.setErrors(null);

        return null;
      } else {

        return { required: true }
      }
    }
  }

  public static validateAccessSection(form: UntypedFormGroup): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return AccessSectionValidator.validate(form);
    };
  }

}
